module.exports = __webpack_public_path__ + "img/no-accounts.8335d22.png";